import React from "react";
import { type ShowDates } from "./models";
import { InputBase } from "components/Atoms/formInputs/InputBase";

interface Props {
  placeholder?: string
  showDates: ShowDates
  onTimeOfPerformanceChanged: (newTimeOfPerformance: string, submit: boolean) => void
}

const TimeOfPerformance = (props: Props) => {
  if (props.showDates.mode === "allDay") {
    return <EditableTimeOfPerformance {...props} />;
  } else {
    return <ReadonlyTimeOfPerformance value={props.showDates.timeOfPerformance} />;
  }
};

const ReadonlyTimeOfPerformance = ({ value }: { value: string }) => {
  return <InputBase value={value} onChange={() => {}} disabled />;
};

const EditableTimeOfPerformance = (props: Props) => {
  const [timeOfPerformance, setTimeOfPerformance] = React.useState(props.showDates.timeOfPerformance ?? "");

  return <InputBase
    placeholder={props.placeholder}
    value={timeOfPerformance}
    maxLength={serverReference.constants.show.maxTimeOfPerformanceLength}
    onChange={data => { setTimeOfPerformance(data); }}
    onBlur={() => { props.onTimeOfPerformanceChanged(timeOfPerformance, false); }}
    onKeyDown={e => e.key === "Enter" && props.onTimeOfPerformanceChanged(timeOfPerformance, true)}
  />;
};

export default TimeOfPerformance;